export default "__VITE_ASSET__ec5d8c89__"